// SNIDCI — habillage des pages de connexion (panneau de marque + placeholders en français).
// Aucune logique d'authentification : les formulaires et scripts Frappe de la page ne sont ni remplacés ni interceptés.
// Seule retouche de saisie : un numéro de téléphone tapé dans l'identifiant est ramené au format canonique (10 chiffres)
// avant l'envoi, comme le fait snidci_core/phone.py côté serveur.
// Chargé via hooks.py : web_include_js.

(function () {
	"use strict";

	const path = document.body && document.body.getAttribute("data-path");
	if (path !== "login" && path !== "update-password") return;

	// Format canonique d'un numéro (identique à snidci_core.phone.normalize_login_identifier) : chiffres seuls, sans indicatif +225.
	function normalizeIdentifier(raw) {
		const text = String(raw || "").trim();
		if (!text || text.indexOf("@") >= 0 || !/^[+\d\s.\-()]+$/.test(text) || !/\d/.test(text)) return text;
		let digits = text.replace(/\D/g, "");
		if (digits.indexOf("00") === 0) digits = digits.slice(2);
		if (digits.indexOf("225") === 0 && digits.length > 10) digits = digits.slice(3);
		return digits.length === 10 ? digits : text;
	}

	const ICON = (d) =>
		`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`;

	// Domaines réellement présents dans la plateforme (même vocabulaire que le menu).
	const DOMAINS = [
		["Stock, mouvements et inventaires", ICON('<path d="M21 8l-9-5-9 5 9 5 9-5z"/><path d="M3 8v8l9 5 9-5V8"/><path d="M12 13v8"/>')],
		["Ventes ELYX, déclarations et clôtures de caisse", ICON('<path d="M6 3h12v18l-3-2-3 2-3-2-3 2z"/><path d="M9 8h6"/><path d="M9 12h6"/>')],
		["Livraisons et approvisionnement des magasins", ICON('<path d="M3 6h11v10H3z"/><path d="M14 9h4l3 3v4h-7z"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/>')],
		["Pointage et présence du personnel", ICON('<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>')],
	];

	function init() {
		const wrapper = document.querySelector(".page-content-wrapper") || document.querySelector("main");
		if (!wrapper || document.querySelector(".sl-brand")) return;

		const logo = "/assets/snidci_core/images/snidci-logo.svg";
		const panel = document.createElement("aside");
		panel.className = "sl-brand";
		panel.setAttribute("aria-label", "SNIDCI");
		panel.innerHTML =
			`<div class="sl-brand-top"><img src="${logo}" alt=""><span class="sl-brand-name">SNIDCI</span></div>` +
			`<div class="sl-brand-mid"><h2>Plateforme de gestion opérationnelle</h2>` +
			`<p>Un seul espace de travail pour suivre le stock, les ventes, la logistique et le personnel.</p>` +
			`<ul class="sl-domains">${DOMAINS.map(([t, i]) => `<li>${i}<span>${t}</span></li>`).join("")}</ul></div>` +
			`<div class="sl-brand-foot">Accès réservé aux utilisateurs autorisés.</div>`;
		wrapper.parentNode.insertBefore(panel, wrapper);

		// Le nom d'application vient du réglage de site « Frappe » : on affiche SNIDCI sans modifier ce réglage.
		document.querySelectorAll(".page-card-head h4").forEach((h) => {
			if (/Frappe/.test(h.textContent)) h.textContent = h.textContent.replace(/Frappe/g, "SNIDCI");
		});

		// Titres restés en anglais dans le gabarit d'origine (traduction manquante).
		const TITLES = { "Forgot Password": "Mot de passe oublié", "Reset Password": "Réinitialiser le mot de passe" };
		document.querySelectorAll(".page-card-head h4").forEach((h) => {
			const t = h.textContent.trim();
			if (TITLES[t]) h.textContent = TITLES[t];
		});

		// Placeholders : l'exemple « jane@example.com » est un reste anglais du formulaire d'origine.
		const email = document.getElementById("login_email");
		if (email) email.setAttribute("placeholder", "Courriel ou téléphone");
		// Capture : s'exécute avant le gestionnaire de soumission de Frappe, qui lit ensuite la valeur du champ.
		document.addEventListener(
			"submit",
			(e) => {
				const field = e.target && e.target.querySelector && e.target.querySelector("#login_email");
				if (field) field.value = normalizeIdentifier(field.value);
			},
			true
		);
		const forgot = document.getElementById("forgot_email");
		if (forgot) forgot.setAttribute("placeholder", "Votre adresse électronique");
	}

	if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
	else init();
})();
